import { uploadUpFile } from '@/utils/request.js'

export default{
    uploadUpFile:uploadUpFile("/file/uploadUpFile")
}


// WEBPACK FOOTER //
// ./src/api/file.js